export default __webpack_public_path__ + "static/media/slide-bg-1.d88e4d0e.png";